import { createContext, useContext } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AddProductToLastWatched, GetLastWatchedProducts } from '../Services/ProductService';
import { useConfig } from './ConfigProvider';
import { useAuth } from './AuthProvider';

const LastWatchedProductsContext = createContext()
const EMPTY_ARRAY = []

export const useLastWatchedProducts = () => {
    return useContext(LastWatchedProductsContext)
}

export const LastWatchedProductsProvider = ({ children }) => {
    const { authState } = useAuth();
    const { api } = useConfig();
    const queryClient = useQueryClient()

    // Lista zależy od kontrahenta, oddziału i magazynu - wszystkie trzy są w kluczu,
    // więc zmiana któregokolwiek daje osobny wpis w cache.
    const { data, refetch } = useQuery({
        queryKey: ['lastWatchedProducts', authState.custId, authState.siteId, authState.whId],
        queryFn: async () => (await GetLastWatchedProducts(api, authState.custId, authState.siteId, authState.whId)).data,
        enabled: authState.user != null,
    })

    const validateArtNo = (value) => {
        if (value === null || value === undefined || value === '') {
            return false
        }
        return true
    }

    const addProductToLastWatched = async (artNo) => {
        try {
            if (!validateArtNo(artNo)) {
                return false
            }
            await AddProductToLastWatched(api, artNo)
            // Dane na serwerze się zmieniły - unieważniamy cache, żeby lista się odświeżyła
            queryClient.invalidateQueries({ queryKey: ['lastWatchedProducts'] })
            return true
        } catch (error) {
            console.log("Error podcas dodawania: " + error)
            return false
        }
    }

    return (
        <LastWatchedProductsContext.Provider value={{
            addProductToLastWatched,
            getLastWatchedProducts: refetch,
            lastWatchedProducts: data ?? EMPTY_ARRAY,
        }}>
            {children}
        </LastWatchedProductsContext.Provider>
    )
}
